import * as types from './types'

export default {
  setTypeformReady: ({ commit }, payload) => {
    commit(types.SET_TYPEFORM_READY, payload)
  },
}
